/** Upper limits (non-inclusive) for media breakpoints */
export const breakpoints = {
    xxsMax: 360,
    xsMax: 640,
    sMax: 820,
    mMax: 1023,
    lMax: 1280,
    xlMax: 1536
};
